import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import Slider from '@mui/material/Slider';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import CircularProgress from '@mui/material/CircularProgress';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

import InputAdornment from '@mui/material/InputAdornment';

import NumberInput from "./NumberInput.js";

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import { ReactSortable, Sortable, MultiDrag, Swap } from "react-sortablejs";

import Grid2 from '@mui/material/Unstable_Grid2'; // Grid version 2

import CardMedia from '@mui/material/CardMedia';

import testImage1 from "./test-1.jpeg"
import testImage2 from "./test-2.jpeg"
import testImage3 from "./test-3.jpeg"
import testImage4 from "./test-4.jpeg"

import DeleteIcon from '@mui/icons-material/Delete';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import OpenWithIcon from '@mui/icons-material/OpenWith';

import Divider from '@mui/material/Divider';

import Fab from '@mui/material/Fab';


import CameraIcon from '@mui/icons-material/Camera';
import FlashlightOnIcon from '@mui/icons-material/FlashlightOn';
import FlashlightOffIcon from '@mui/icons-material/FlashlightOff';
import FlipIcon from '@mui/icons-material/Flip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';

// import Switch from '@mui/material/Switch';

import TextManager from '../TextManager.js';

import Webcam from "react-webcam";
export default class Camera extends React.Component {


    state = {
        imgSrc: null,
        // zoomSettings: null,
        zoomSettings: {
            available: false,
            min: 0,
            max: 1,
            step: 0.1,
            oninput: (event) => {}
        },

        // torchSettings: null,
        torchSettings: {
            available: false,
        },

        flashlightEnabled: false,

        mirrorEnabled: false,
    }

    

    zoomSliderRef = React.createRef();
    webcamRef = React.createRef();

    capture() {
        const imageUrl = this.webcamRef.current.getScreenshot();

        // const a = document.createElement("a");
        // document.body.appendChild(a);
        // a.style = "display: none";
        // a.href = imageUrl;
        // a.download = "photo.jpeg";
        // a.click();

        const originalImage = new Image();
		originalImage.src = imageUrl;

		originalImage.onload = () => {
            const width = originalImage.height / 1.414;
            const x = (originalImage.width - width) * 0.5;
            
            let canvas = this.getClippedImageCanvas(originalImage, x, 0, width, originalImage.height);

            canvas.toBlob((blob) => {
                let file = new File([blob], "fileName.jpg", { type: "image/jpeg" })
                let event = new Event("photoCaptured");
                event.file = file;
                this.props.onPhotoCaptured?.call(this, event);
                this.props.close()
            }, 'image/jpeg');

            //let clippedImageUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

            // const a = document.createElement("a");
            // document.body.appendChild(a);
            // a.style = "display: none";
            // a.href = clippedImageUrl;
            // a.download = "photo.jpeg";
            // a.click();
		};
    }

    getClippedImageCanvas(image, x, y, width, height) {
		var canvas = document.createElement("canvas"),
			ctx = canvas.getContext("2d");

		canvas.width = width;
		canvas.height = height;

		ctx.drawImage(image, x, y, width, height, 0, 0, width, height);

		return canvas;
	}


    componentDidMount() {
        // if (!navigator.mediaDevices?.enumerateDevices) {
        //     console.log("enumerateDevices() not supported.");
        //   } else {
        //     // List cameras and microphones.
        //     navigator.mediaDevices
        //       .enumerateDevices()
        //       .then((devices) => {
        //         devices.forEach((device) => {
        //           console.log(`${device.kind}: ${device.label} id = ${device.deviceId}`);
        //         });
        //       })
        //       .catch((err) => {
        //         console.error(`${err.name}: ${err.message}`);
        //       });
        //   }
    }

    render() {
        const videoConstraints = {
            facingMode: "environment",
            width: 1600,
            height: 1600
        };

        const createFab = (Icon, settings) => {
            const size = settings?.size || 50;
            const color = settings?.color || null;
            const onClick = settings?.onClick;
            const getDisabled = settings?.getDisabled;

            const disabled = getDisabled == null? false : getDisabled();
            
            return (<Fab classes={"disabledFab"} color={color}
                sx={{
                    bgcolor: color == null ? "rgba(255,255,255,1.0)" : null,
                    maxHeight: size,
                    minHeight: size,
                    minWidth: size,
                    maxWidth: size,
                    "&.Mui-disabled": {
                        background: "grey",
                        color: "lightGrey"
                    }
                }}
                onClick={onClick}
                disabled={disabled}
            >
                <Icon sx={{ width: "60%", height: "auto" }} />
            </Fab>)
        }

        const narrowScreenQuery = "@media (max-aspect-ratio: 210/297)";

        const zoomUI = (
            <Box direction="column" sx={{
                position: "absolute",

                overflow: "hidden",

                width: "fit-content",
                height: "100%",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                right: "0",

                // bgcolor: "rgba(0,255,255,0.5)",
            }}>
                <Stack direction="column" sx={{
                    width: "fit-content",
                    height: "50%",

                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <ZoomInIcon sx={{fill:"white"}} />

                    <Slider
                        disabled={!this.state.zoomSettings.available}
                        min={this.state.zoomSettings.min}
                        max={this.state.zoomSettings.max}
                        step={this.state.zoomSettings.step}
                        defaultValue={this.state.zoomSettings.defaultValue}
                        onChange={(e, v) => {
                            this.state.zoomSettings.oninput(v)}
                        }
                        key={this.zoomSliderRef}
                        sx={{
                            '& input[type="range"]': {
                                WebkitAppearance: 'slider-vertical',
                            },
                            margin: "15px 0",
                        }}
                        orientation="vertical"
                    />

                    <ZoomOutIcon sx={{fill:"white"}} />
                </Stack>
            </Box>
        );


        const hintFrame = (
            <Box sx={{
                position: "absolute",

                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                width: "100%",
                height: "100%",

                // bgcolor: "rgba(0,255,255,0.5)",
            }}>

                <Box sx={{
                    position: "relative",
                    aspectRatio: "210 / 297",
                    height: "95%",
                    bgcolor: "transparent",
                    borderRadius: "10px",
                    borderWidth: "6px",
                    borderStyle: "solid",
                    borderColor: "rgba(0,130,240,1)",

                    display: "flex",
                    justifyContent: "center",

                    [narrowScreenQuery]: {
                        aspectRatio: "210 / 297",
                    }
                }}>

                    <Typography sx={{
                        color: "white",
                        textShadow: "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black, 0px -1px 0 black, 0px 1px 0 black, -1px 0px 0 black, 1px 0px 0 black",
                        textAlign: "center",
                        lineHeight: "20px",
                        fontSize: "20px",
                        marginTop: "2%"
                    }}>
                        {TextManager.getText("camera_inside_frame")}
                    </Typography>

                    {zoomUI}

                </Box>

            </Box>
        );


        return (
            <Box sx={{
                position: "absolute",
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                bgcolor: "black",

            }}>
                <Stack direction="column"
                    sx={{
                        display: 'flex',
                        height: "100%"
                    }}
                >

                    <Box sx={{
                        // bgcolor: "red",
                        width: "100%",
                        height: "50px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                        [narrowScreenQuery]: {
                            flexGrow: 1
                        }
                    }} >
                        <IconButton onClick={this.props.close}>
                            <ArrowBackIcon sx={{ fill: "white" }} />
                            <Typography sx={{
                                color: "white",
                                fontSize: 20,
                            }}>
                                {TextManager.getText("back")}
                            </Typography>
                        </IconButton>
                    </Box>

                    <Box sx={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",

                        // bgcolor: "blue",
                        overflow: "hidden",

                        width: "100%",
                        height: "100%",
                        [narrowScreenQuery]: {
                            height: "unset",
                            aspectRatio: "210 / 297",
                        }
                    }}>
                        <Box sx={{
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            width: "100%",
                            height: "100%",

                        }}>
                            <Webcam
                                style={{
                                    height: "100%",
                                }}
                                mirrored={this.state.mirrorEnabled}
                                forceScreenshotSourceSize={true}
                                // minScreenshotWidth={1920}
                                // minScreenshotHeight={1080}
                                screenshotQuality={1}
                                audio={false}
                                ref={this.webcamRef}
                                screenshotFormat="image/jpeg"
                                videoConstraints={videoConstraints}
                                onUserMedia={(mediaStream) => {
                                    // console.log(mediaStream)
                                    const [track] = mediaStream.getVideoTracks();
                                    const capabilities = track.getCapabilities();
                                    // const settings = track.getSettings();

                                    if (capabilities.zoom) {
                                        this.setState({zoomSettings: {
                                            available: true,
                                            min: capabilities.zoom.min,
                                            max: capabilities.zoom.max,
                                            step: capabilities.zoom.step,
                                            defaultValue: capabilities.zoom.min,
                                            oninput: (v) => {
                                                // console.log(v)
                                                track.applyConstraints({advanced: [ {zoom: v} ]});
                                            },
                                        }});
                                    }

                                    if (capabilities.torch) {
                                        this.setState({torchSettings: {
                                            available: true,
                                            onChange: (v) => {
                                                track.applyConstraints({advanced: [ {torch: v} ]});
                                            },
                                        }});
                                    }

                                    //console.log(mediaStream.getVideoTracks()[0].getSettings());
                                    // console.log(capabilities)

                                    
                                }}
                            />
                        </Box>

                        {hintFrame}

                    </Box>

                    <Box sx={{
                        // bgcolor: "red",
                        width: "100%",
                        height: "100px",
                        [narrowScreenQuery]: {
                            flexGrow: 1
                        }
                    }} >
                        <Stack
                            spacing={2}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                // bgcolor: "green",
                                width: "100%",
                                height: "100%",
                            }}
                        >
                            {createFab(FlipIcon, {
                                onClick: (e) => {
                                    this.setState({mirrorEnabled: !this.state.mirrorEnabled})
                                }
                            })}

                            {createFab(CameraIcon, {
                                size: 60, color: "primary", onClick: (e) => { this.capture() }
                            })}

                            {createFab(this.state.flashlightEnabled? FlashlightOffIcon : FlashlightOnIcon, {
                                getDisabled: () => {
                                    return !this.state.torchSettings.available;
                                },
                                onClick: (e) => {
                                    // console.log(this.state.torchSettings.onChange)
                                    this.state.torchSettings.onChange(!this.state.flashlightEnabled);

                                    this.setState({flashlightEnabled: !this.state.flashlightEnabled})
                                }
                            })}

                        </Stack>
                    </Box>




                </Stack>
            </Box>
        )
    }
}